class FooterBlock extends HTMLElement {
  constructor() {
    super();

    window.addEventListener(
      'resize',
      this.resize.bind(this)
    );
  }

  resize() {
    console.log(window.innerWidth);
  }
}

customElements.get('footer-block') || customElements.define('footer-block', FooterBlock);